import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  private route = inject(ActivatedRoute);

  title: string;

  ngOnInit() {
    this.route.data.subscribe((d) => {
      this.title = d.title;
    });
  }
}
